import { FC } from 'react';
// 组件
import { Cascader, CascaderProps } from 'antd';
import SuperCascader from './superCascader';
// 常量
import { SuperCascaderProps } from './interface';

export type ISuperCascaderComponent = FC<SuperCascaderProps> & {
  SHOW_CHILD: CascaderProps['showCheckedStrategy'];
  SHOW_PARENT: CascaderProps['showCheckedStrategy'];
};
/** 级联选择 */
const TransSuperCascader = SuperCascader as ISuperCascaderComponent;
TransSuperCascader.SHOW_CHILD = Cascader.SHOW_CHILD;
TransSuperCascader.SHOW_PARENT = Cascader.SHOW_PARENT;

export default TransSuperCascader;
